import { ChangeDetectorRef, Component, Input, IterableDiffer, IterableDiffers, OnInit} from '@angular/core';
import { EventoUnidad} from '../../../../_models/evento-unidad';
import { UnidadEtapasService} from '../_services/unidad-etapas.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomAlertService} from '../../../../_components/custom-alert/custom-alert.service';
import * as moment from 'moment';
import * as extendMoment from 'moment-range';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { GlobalService } from 'src/app/_services/global.service';


@Component({
  selector: 'unidad-eventos-aprendizaje',
  standalone: false,
  templateUrl: 'unidad-eventos-aprendizaje.component.html',
  styleUrls: ['unidad-eventos-aprendizaje.component.scss','../../unidad-etapas/unidad-etapas-generales.scss']
})

export class UnidadEventosAprendizajeComponent implements OnInit {

  @Input()
  _eventos: EventoUnidad[];
  eventos: EventoUnidad[] = [];
  eventosReseter;
  @Input()
  fechaInicio: string;
  @Input()
  fechaFin: string;

  @Input()
  unidadID;
  @Input()
  unidad;
  @Input()
  areas: any[];

  tiempo: string;

  calendarioActivo = false;
  listaActiva = true;

  differ: IterableDiffer<any>;

  resumenAbierto = false;

  materiasDisponibles: any;

  momentRange;
  initialDayCurrWeek: moment.Moment;
  endDayCurrWeek: moment.Moment;
  filtroActivo = 'todos';

  filterForm = new UntypedFormGroup({
    materias: new UntypedFormControl([]),
    cursos: new UntypedFormControl([])
  });
  filterFormSubscription: Subscription;

  constructor(differs: IterableDiffers,
              private unidadEtapasService: UnidadEtapasService,
              private customAlertService: CustomAlertService,
              private snackBar: MatSnackBar,
              private cd: ChangeDetectorRef,
              private globalService: GlobalService
  ) {
    this.differ = differs.find([]).create(null);
  }

  ngOnInit() {
    this.materiasDisponibles = this.unidad.materias;
    this.unidadEtapasService.getUnidadEtapasObservable().subscribe(data => {
      if (!data) {
        return false;
      }
      if (data.tipo === 'actualizar-materias-periodo') {
        this.materiasDisponibles = data.materias;
      }

      if (data.tipo === 'agregar-evento-unidad') {
        this._eventos.push(data.objeto);
        // this.eventosReseter.push(data.objeto);
        this.updateView(this._eventos);
      }

      if (data.tipo === 'actualizar-calendario-eventos') {
        const indice = this._eventos.findIndex(ev => +ev.id === +data.evento.id),
          that = this;
        this.eventosReseter[indice] = data.evento;
        this._eventos[indice] = data.evento;
        this.updateView(this._eventos);
        if (this.calendarioActivo) {
          this.calendarioActivo = false;
          setTimeout(() => {
            that.calendarioActivo = true;
          }, 250);
        }
      }
    });
    this.eventosReseter = this._eventos;
    this.updateView(this._eventos);
    this.momentRange = extendMoment.extendMoment(moment);

    this.initialDayCurrWeek = moment(new Date());
    this.endDayCurrWeek = moment(new Date());
    this.initialDayCurrWeek.startOf('isoWeek');
    this.endDayCurrWeek.startOf('isoWeek').add(5, 'd');

    this.filterFormSubscription = this.filterForm.valueChanges.subscribe(res => {
      // this.filterForm.updateValueAndValidity();
      this.mostrarRango();
    });

  }

  ngDoCheck() {
    const changes = this.differ.diff(this._eventos);
    if (changes) {
      this.updateView(this._eventos);
    }
  }

  updateView(eventos) {
    this.eventos = [];
    this.eventos = eventos.map(eventoUnidad => {
      return new EventoUnidad(eventoUnidad);
    });
    const that = this;
    setTimeout(() => {
      that.cd.detectChanges();
    }, 250);
  }

  eliminarEvento(id) {
    const evidenciaIndex = this._eventos.findIndex(evidencia => +evidencia.evento.id === +id);

    this.unidadEtapasService.quitarDeUnidad('evento', this.unidadID, id).subscribe(res => {
      this._eventos.splice(evidenciaIndex, 1);
      this.updateView(this._eventos);
      this.snackBar.open(`La evidencia ${id} se ha eliminado de la unidad satisfactoriamente.`, null, {duration: 2500});
    }, err => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No ha sido posible eliminar la evidencia de la unidad. <br> ${err.error} <br> Código de error: ${err.statusText}`
      });
    });
  }

  toggleEstadoResumen(value: boolean) {
    this.resumenAbierto = value;
  }

  mostrarRango() {
    let salida = [];
    this._eventos = this.eventosReseter;
    if (this.filtroActivo === 'todos') {
      salida = this._eventos;
    }

    if (this.filtroActivo === 'hoy') {
      this._eventos.map(evento => {
        evento.eventoMaterias.map(eventoMateria => {
          const eventoFecha = moment(eventoMateria.fechaAplicar.substring(0, 10), 'YYYY-MM-DD');
          if (moment(eventoFecha).isSame(new Date, 'day') &&
            salida.filter(el => +el.id === +evento.id).length === 0) {
            salida.push(evento);
          }
        });
      });
    }

    if (this.filtroActivo === 'semana') {
      this._eventos.map(evento => {
        evento.eventoMaterias.map(eventoMateria => {
          const eventoFecha = moment(eventoMateria.fechaAplicar.substring(0, 10), 'YYYY-MM-DD');
          if (this.momentRange.range(this.initialDayCurrWeek, this.endDayCurrWeek).contains(eventoFecha) &&
            salida.filter(el => +el.id === +evento.id).length === 0) {
            salida.push(evento);
          }
        });
      });
    }
    // Implementación de filtros
    const values = this.filterForm.value;
    const salidaFiltrada = salida.filter(item => {
      let areas = [];
      item.metas.forEach(element => {
        areas = this.globalService.unionArrays(areas, element.areas.map(area => area.id))
      });
      let filtradoCursos = true;
      let filtradoAreas = true;
      if (values.cursos.length > 0) {
        const arrayCursos = this.globalService.intersectionArrays(values.cursos,
          item.eventoMaterias.map(materia => materia.materiaCursoPeriodoID));
        filtradoCursos = arrayCursos.length > 0;
      }
      if (values.materias.length > 0) {
        const arrayAreas = this.globalService.intersectionArrays(values.materias,
          areas);
        filtradoAreas = arrayAreas.length > 0;
      }
      return filtradoCursos && filtradoAreas;
    });
    this._eventos = salidaFiltrada;
    this.updateView(salidaFiltrada);
  }

  primerDiaSemana() {
  }
}
